import {WebsiteTourConstant} from "../redux_constants/websitetour.constant";


const InitialState = {
    tourActive: false,
    tourActiveForScan: false

}

export const websiteTourReducer = ( state = InitialState , action) => {
    const currentInfo = Object.assign({}, state);
    switch(action.type){
        case WebsiteTourConstant.ACTIVATE:
            currentInfo.tourActive = true;
            return currentInfo
        case WebsiteTourConstant.DEACTIVATE:
            currentInfo.tourActive = false;
            return currentInfo
        case WebsiteTourConstant.ACTIVATE_FOR_SCAN:
            currentInfo.tourActiveForScan = true;
            return currentInfo
        case WebsiteTourConstant.DEACTIVATE_FOR_SCAN:
            currentInfo.tourActiveForScan = false;
            return currentInfo
        default :
            return state
    }
}